<template>
  <div class="container-fluid">
    <div class="card mb-3" v-if="state==0" >
          <div class="card-header fs-1 fb-1">Where Used Query</div>
          <div class="card-body">
            <StockSearchVue @select="SelectStockCode"  PartCategory="B"></StockSearchVue>
          </div>
        </div>
    
    <div v-if="state==1">
      <span v-show='loading' class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </span>
    <div v-show='!loading' >
        <div class="card mb-3" >
          <div class="card-header fs-1 fb-1">Where Used Query</div>
          <div class="card-body">
            <h5 class="card-title">Stock Code: {{FlatBom.StockCode}}</h5>
            <p class="card-text">Description: {{FlatBom.Description}}</p>
          </div>
        </div> 
        <div v-for="(row,idx) in FlatBom.Bom" :key="idx" class="StartCard">
          <div >
           <div ><span> {{row.StockCode}} ( {{qtyFormat(row.qty)}} ) </span>
            <span class="pl-1" >
              {{row.Description}} 
            </span>
            </div>
            <div >
              <div v-if="row.Bom.length>0" >
                <NestedPartsVue v-for="b in row.Bom" :Bom="b" :key="b.StockCode" Level=1></NestedPartsVue>
              </div>

            </div>
          </div>
          <hr/>
        </div> 
    </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index";
import StockSearchVue from '../../../components/StockSearch/StockSearch.vue';
import {BaseDataService} from '../../../services/BaseData.service';
import NestedPartsVue from './nestedParts.vue'
export default {
  components: {
    StockSearchVue,
    NestedPartsVue 
  },
  data: () => ({
    loading:true,
    StockCodeInput:"",
    StockListSearch:[],
    CurrentStockCode:"",
    CurrentRoute:"0",
    state:0,
    FlatBom:{}
  }),
  watch:{
    $route (to, from){
      this.navChange();
      }
  },
  mounted(){
    this.navChange();
  },
  methods: { 
    SelectStockCode(row){        
      router.push("/flatbom/"+row.StockCode + "/"+row.route);
    },
    navChange(){
      if(this.$route.params.stockCode){
        this.state=1;
         
        this.$store.commit("bomStockCode/setSelectSockCode",this.$route.params.stockCode);
        this.CurrentStockCode = this.$route.params.stockCode;
        this.CurrentRoute = this.$route.params.route;
        this.state=1;
        this.loading=true;
        BaseDataService.getFlatBom(this.$route.params.stockCode,this.$route.params.route).then(x=>{
            this.FlatBom=x.data;
            this.loading = false;
            
        });
      }else{
        this.state=0;
        this.loading=false;
      }
    },
    qtyFormat(Num){
        return Number(Num).toFixed(3)
    }
  }
}
</script>

<style>
.StartCard{
  padding-left: 1.5rem !important;
  font-family: var(--bs-font-monospace) !important;
  font-size: 0.8rem !important;
}
.pl-1{
    padding-left: 5px;
}
</style>